import { motion } from "framer-motion";
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * AnimatedScrollFooter
 * - n'anime que lorsque le footer entre en viewport
 * - relance l'animation à chaque changement de route
 */
const AnimatedScrollFooter = ({ children, duration = 0.7, className }) => {
  const { pathname } = useLocation();
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  // observe le node et déclenche l'animation une fois visible
  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.unobserve(node);
        }
      },
      { root: null, rootMargin: "0px 0px -80px 0px", threshold: 0.12 }
    );

    obs.observe(node);
    return () => {
      try {
        obs.disconnect();
      } catch (e) {}
    };
  }, []); // mount only

  // quand la route change, réinitialise la visibilité et ré-observe pour relancer l'animation
  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    // reset state
    setVisible(false);

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.unobserve(node);
        }
      },
      { root: null, rootMargin: "0px 0px -80px 0px", threshold: 0.12 }
    );

    obs.observe(node);
    return () => {
      try {
        obs.disconnect();
      } catch (e) {}
    };
  }, [pathname]);

  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration } },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={visible ? "visible" : "hidden"}
      variants={variants}
      className={className}
      style={{ willChange: "transform, opacity" }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedScrollFooter;
